// Fetch list

export const FETCH = 'customerAddresses.FETCH'
export const FETCH_STARTED = 'customerAddresses.FETCH_STARTED'
export const FETCH_FULFILLED = 'customerAddresses.FETCH_FULFILLED'
export const FETCH_REJECTED = 'customerAddresses.FETCH_REJECTED'
export const FETCH_CANCELLED = 'customerAddresses.FETCH_CANCELLED'

export const SORTING_CHANGED = 'customerAddresses.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'customerAddresses.FETCH_ONE'
export const FETCH_ONE_STARTED = 'customerAddresses.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'customerAddresses.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'customerAddresses.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'customerAddresses.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'customerAddresses.SAVE'
export const SAVE_STARTED = 'customerAddresses.SAVE_STARTED'
export const SAVE_FULFILLED = 'customerAddresses.SAVE_FULFILLED'
export const SAVE_REJECTED = 'customerAddresses.SAVE_REJECTED'
export const SAVE_CANCELLED = 'customerAddresses.SAVE_CANCELLED'
export const SAVE_DUPLICITY_FOUND = 'customerAddresses.SAVE_DUPLICITY_FOUND'

// Delete

export const DELETE = 'customerAddresses.DELETE'
export const DELETE_STARTED = 'customerAddresses.DELETE_STARTED'
export const DELETE_FULFILLED = 'customerAddresses.DELETE_FULFILLED'
export const DELETE_REJECTED = 'customerAddresses.DELETE_REJECTED'
export const DELETE_CANCELLED = 'customerAddresses.DELETE_CANCELLED'

// Restore

export const RESTORE = 'customerAddresses.RESTORE'
export const RESTORE_STARTED = 'customerAddresses.RESTORE_STARTED'
export const RESTORE_FULFILLED = 'customerAddresses.RESTORE_FULFILLED'
export const RESTORE_REJECTED = 'customerAddresses.RESTORE_REJECTED'
export const RESTORE_CANCELLED = 'customerAddresses.RESTORE_CANCELLED'

// Export

export const EXPORT = 'customerAddresses.EXPORT'
export const EXPORT_FULFILLED = 'customerAddresses.EXPORT_FULFILLED'

// Find

export const FIND = 'customerAddresses.FIND'
export const FIND_STARTED = 'customerAddresses.FIND_STARTED'
export const FIND_FULFILLED = 'customerAddresses.FIND_FULFILLED'
export const FIND_REJECTED = 'customerAddresses.FIND_REJECTED'
export const FIND_CANCELLED = 'customerAddresses.FIND_CANCELLED'
